import { useState } from 'react';
import { authApi } from '../lib/authApi';
import { useAuth } from './AuthContext';
import { AuthError, AuthScreen } from './AuthScreen';

export function LoginForm({ notice }: { notice?: string }) {
  const { refresh } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await authApi.login(email, password);
      await refresh();
    } catch {
      setError('Неверная почта или пароль.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthScreen title="Вход в Ygrik Board" subtitle={notice}>
      <form className="auth-form" onSubmit={submit}>
        <label className="auth-field">
          <span>Почта</span>
          <input
            type="email"
            autoFocus
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
        </label>
        <label className="auth-field">
          <span>Пароль</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>

        <AuthError message={error} />

        <button type="submit" className="primary-btn auth-submit" disabled={busy}>
          {busy ? 'Вход…' : 'Войти'}
        </button>
      </form>
      <p className="auth-hint">
        Нет аккаунта? Попросите администратора организации отправить вам ссылку-приглашение.
      </p>
    </AuthScreen>
  );
}
